export default {
    methods: {
        getHeader (columns) {
            let cols = {}
            for (let index = 0; index < columns.length; index++) {
                const col = columns[index]
                cols[col.name] = {
                    label: col.name,
                    position: index + 1,
                    visible: true,
                    align: 'left',
                    search: false,
                    type: col.type,

                }
            }
            return cols
        },
        decideElementIcon (type) {
            switch (type) {
                case 'table':
                    return 'mdi-table'
                case 'chart':
                    return 'mdi-poll'
                case 'counter':
                    return 'mdi-counter'
                default:
                    break
            }
        },
    },
}
